module.exports = __webpack_public_path__ + "media/images/register-44a32a10.png";